module.exports = require('./helpers/bundle-url').getBundleURL('bc4bY') + "empty_box.b403b876.svg";